import { render, staticRenderFns } from "./DataRecordDetail.vue?vue&type=template&id=98384f54&scoped=true"
import script from "./DataRecordDetail.vue?vue&type=script&lang=js"
export * from "./DataRecordDetail.vue?vue&type=script&lang=js"
import style0 from "./DataRecordDetail.vue?vue&type=style&index=0&id=98384f54&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98384f54",
  null
  
)

export default component.exports